const reactEvents = new Set((
	"onCopy onCut onPaste " +
	"onCompositionEnd onCompositionStart onCompositionUpdate " +
	"onKeyDown onKeyPress onKeyUp " +
	"onFocus onBlur " +
	"onChange onInput onInvalid onReset onSubmit " +
	"onError onLoad " +
	"onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp " +
	"onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut " +
	"onSelect " +
	"onTouchCancel onTouchEnd onTouchMove onTouchStart " +
	"onScroll " +
	"onWheel " +
	"onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaitin " +
	"onLoad onError " +
	"onAnimationStart onAnimationEnd onAnimationIteration " +
	"onTransitionEnd " +
	"onToggle"
).split(" "));
export default function filterPropsEvents(props)
{
	const filtered = {};
	for (const p in props)
	{
		if (reactEvents.has(p))
		{
			filtered[p] = props[p];
		}
	}

	return filtered;
}